<!-- Custom Header -->
@if (!isEmbedded) {
<div class="flex items-center justify-between px-sm py-xs sticky top-0 z-10">
  <div class="flex items-center gap-xs">
    <h3 class="text-md font-bold text-dark-text capitalize m-0">
      {{ 'alerts' | translate }}
    </h3>
    <app-text-button
      [label]="'viewAll' | translate"
      (clicked)="onViewAll()"
      color="var(--color-primary)"
      styleClass="text-xs ml-sm"
      [noHover]="true"
    ></app-text-button>
  </div>
  <div class="flex items-center gap-xs">
    <!--     <button
        (click)="onMarkAllAsRead()"
        [disabled]="totalUnreadCount() === 0"
        class="text-xs font-bold text-primary hover:underline cursor-pointer bg-transparent border-none disabled:opacity-50 disabled:cursor-not-allowed disabled:no-underline"
      >
        {{ 'markAllAsRead' | translate }}
      </button> -->
    <button
      (click)="onClose()"
      class="p-2 rounded-full cursor-pointer hover:bg-bg-soft text-gray-text hover:text-dark-text transition-colors"
    >
      <svg
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
</div>
}

<!-- Scrollable List -->
<div
  class="flex-1 overflow-y-auto px-sm pb-sm notifications-list min-h-0"
  (scroll)="onScroll($event)"
>
  <div class="flex flex-col gap-sm">
    @for (group of groupedAlerts(); track group.title) {
    <div class="bg-white rounded-xl overflow-hidden shadow-card">
      <!-- Group Header -->
      <div
        class="px-sm py-xs text-xs font-bold uppercase tracking-wider text-gray-text bg-white border-b border-line flex justify-between items-center"
      >
        <span>{{ group.title | translate }}</span>
        <!--        @if (group.unreadCount > 0) {
        <span class="text-xs text-primary font-bold uppercase tracking-wider">
          {{ group.unreadCount }} {{ 'unread' | translate }}
        </span>
        } -->
      </div>

      <!-- Items List inside the Card -->
      <div class="flex flex-col">
        @for (item of group.items; track item.id) {
        <div
          class="relative transition-colors duration-200 border-b border-line last:border-0 hover:bg-bg-soft"
        >
          <app-activity-item
            appClickable
            class="block p-sm cursor-pointer"
            [item]="item"
            (click)="onAlertClick(item)"
            (markAsRead)="markAsRead($safeNavigationMigration(item.data?.id)!, item.instanceId!)"
          ></app-activity-item>
        </div>
        }
      </div>
    </div>
    } @empty { @if (!isLoading) {
    <app-empty-state
      [title]="'noUpdates' | translate"
      [subtitle]="'noUpdatesDetail' | translate"
      illustration="no_data_illustration.svg"
      [size]="120"
    ></app-empty-state>
    } } @if (isLoading) {
    <div class="flex flex-col gap-sm">
      @for (i of [1,2,3]; track i) {
      <div
        class="bg-white rounded-xl border border-line p-sm flex gap-xs animate-pulse"
      >
        <div class="w-10 h-10 rounded-xl bg-bg-soft"></div>
        <div class="flex-1 flex flex-col gap-xs">
          <div class="h-2.5 bg-bg-soft rounded-full w-[30%]"></div>
          <div class="h-2.5 bg-bg-soft rounded-full w-[90%]"></div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
